import { useState, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { HyperLinks } from '@User/components'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Link from '~/core/Link'
import Image from '~/core/Image'
import { ConfigOverridesWarningShroud } from '~/components/FixedLayout'
import icons from '~/apps/consumer/icons'
import { LOGIN_PATH } from '~/redux-modules/preferences'
import getColor from '~/lib/getColor'

import styles from './styles.css'

const SIGNUP = 'sign-up'
const LOGIN = 'log-in'
const SIGNUP_PATH = '/signup'

export default function UnauthenticatedLayout(props: {
    children: ReactNode
    placement: string
    queryString?: string
    showSignupLink?: boolean
    showLoginLink?: boolean
    showBackground?: boolean
}) {
    const {
        children,
        placement,
        queryString,
        showSignupLink,
        showLoginLink,
        showBackground,
    } = props

    const { search } = useLocation()

    const params = new URLSearchParams(search)

    const utmCampaign = params.get('utm_campaign')

    const [showDefault, setShowDefault] = useState<boolean>(true)

    const logoUrl =
        'https://www.fictiv.com/wp-content/uploads/login-page-logos/'

    return (
        <Box
            alignItems="center"
            backgroundColor="vendorAppBackground"
            className={showBackground && styles.withBackgroundImage}
            direction="col"
            height="100vh"
            padding="48px 0"
            width="100vw"
        >
            <ConfigOverridesWarningShroud />
            {Boolean(utmCampaign) && (
                <img
                    src={`${logoUrl}${utmCampaign}.png`}
                    onLoad={() => setShowDefault(false)}
                    style={{ display: 'none' }}
                />
            )}
            <Box direction="col" justifyContent="center" flexGrow="1">
                <Box direction="col" alignItems="center">
                    <Box alignItems="center" marginBottom="16px">
                        <Image src={icons.fictivIconGreen} height="30" />
                        {!showDefault && (
                            <>
                                <Text
                                    fontSize="20px"
                                    fontWeight={700}
                                    color={getColor('blackAlpha65')}
                                    style={{ margin: '5px 24px 0px' }}
                                >
                                    +
                                </Text>
                                <img src={`${logoUrl}${utmCampaign}.png`} />
                            </>
                        )}
                    </Box>
                    {children}
                    {showSignupLink && (
                        <Text>
                            Need to create an account?{' '}
                            <Link
                                name={SIGNUP}
                                placement={placement}
                                to={SIGNUP_PATH}
                                search={queryString}
                            >
                                Sign up
                            </Link>
                        </Text>
                    )}
                    {showLoginLink && (
                        <Text>
                            Go back to{' '}
                            <Link
                                name={LOGIN}
                                placement={placement}
                                to={LOGIN_PATH}
                                search={queryString}
                            >
                                Log in
                            </Link>
                        </Text>
                    )}
                </Box>
            </Box>
            <HyperLinks placement={placement} />
        </Box>
    )
}
